/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.searchPostsV2'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  sort: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['recent', 'top'] }>(),
  ),
  urls: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'uri' })),
  ),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      25,
    ),
  ),
  query: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  since: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  until: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  allTime: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  authors: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' })),
  ),
  domains: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  hasMedia: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  hasVideo: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  hashtags: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string({ maxLength: 640, maxGraphemes: 64 }),
    ),
  ),
  mentions: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' })),
  ),
  following: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  languages: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'language' })),
  ),
  excludeUrls: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'uri' })),
  ),
  repliesOnly: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  queryLanguage: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['ja', 'zh', 'ko', 'th', 'ar'] }>(),
  ),
  threadRootUri: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'at-uri' }),
  ),
  embeddedAtUris: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' })),
  ),
  excludeAuthors: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' })),
  ),
  excludeDomains: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  excludeReplies: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  replyParentUri: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'at-uri' }),
  ),
  excludeHashtags: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string({ maxLength: 640, maxGraphemes: 64 }),
    ),
  ),
  excludeMentions: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-identifier' })),
  ),
  excludeLanguages: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'language' })),
  ),
  excludeEmbeddedAtUris: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' })),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  posts: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<FeedDefs.PostView>((() => FeedDefs.postView) as any),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  hitsTotal: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  detectedQueryLanguages: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string<{ knownValues: ['ja', 'zh', 'ko', 'th', 'ar'] }>(),
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Find posts matching a search query or filters, returning search hits for matching post records. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['BadQueryString'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
